import React, {useRef, useState} from "react"
import {DefaultTablePagination, Table, Tooltip} from "../../../components/Elements/appUtils"
import {patientCreditNoteFxn} from "../actions/patients";
import moment from "moment";
import {customAxios as axios, getToken} from "../../../request";
import {getProductReport} from "../../purchase/api";

const PatientCreditNoteList = (props) => {
    let tableRef = useRef()
    const [productsDetails, setProductsDetails] = useState({});
    const [loadingDetails, setLoadingDetails] = useState({});
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.customerId = props.customerId;
            params.sortField = "_id"
            params.sortOrder = "descend"
            let resp = await patientCreditNoteFxn(params);
            resolve(resp)
        })
    }
    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Vendor",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.name}</span>,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
        },
        {
            title: "Credit Note Date",
            dataIndex: "creditNoteDate",
            key: "creditNoteDate",
            render: (text) => <span>{moment(text).format("DD-MMM-YY, hh:mm A")}</span>,
        },
        {
            title: "State",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.state}</span>,
        },
        {
            title: "Total Quantity",
            dataIndex: "quantity",
            key: "quantity",
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text) => <span>Rs. {text}</span>,
        },

        {
            title: "sale Category",
            dataIndex: "saleCategory",
            key: "saleCategory",
            render: (text, record) => {
                return (
                    <>
                        {record && record.saleCategory &&
                        record.saleCategory.name ?
                            record.saleCategory.name
                            : null}
                    </>)
            },
        },
        {
            title: "Received Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            render: (text) => <span>Rs. {text}</span>,
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
            render: (text) => <span>Rs. {text}</span>,
        }
    ];


    const fetchProductDetails = async (creditNoteId) => {
        if (!creditNoteId || productsDetails[creditNoteId]) {
            return
        }

        setLoadingDetails(prev => ({...prev, [creditNoteId]: true}))
        try {
            let config = {
                params: {creditNoteId: creditNoteId},
                ...(await getToken()),
            };
            const response = await axios.get(getProductReport(), config);

            setProductsDetails(prev => ({...prev, [creditNoteId]: response.data?.data || []}))
        } catch (error) {
            setProductsDetails(prev => ({...prev, [creditNoteId]: []}))
        } finally {
            setLoadingDetails(prev => ({...prev, [creditNoteId]: false}))
        }
    }
    const expandedRowRender = (record) => {
        const id = record._id;
        const details = productsDetails[id] || [];
        const loading = loadingDetails[id];

        if (loading) {
            return <div style={{padding: 16}}>Loading credit note details...</div>
        }

        if (!details.length) {
            return <div style={{padding: 16}}>No sale details found.</div>
        }


        return (
            <div style={{padding: 16, overflowX: 'auto'}}>
                <table className="table table-bordered table-xs mb-0">
                    <thead>
                    <tr>
                        <td>Sr no.</td>
                        <td>Product Name</td>
                        <td>Report Type</td>
                        <td>Mfg Date</td>
                        <td>Exp Date</td>
                        <td>Batch</td>
                        <td>Qty.</td>
                        <td>Sale Price</td>
                        <td>Price</td>
                        <td>Dis Amt.</td>
                        <td>Taxable Amt.</td>
                        <td>CGST Amt.</td>
                        <td>SGST Amt.</td>
                        <td>Net Amt.</td>
                    </tr>
                    </thead>
                    <tbody>
                    {details.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.productName}</td>
                            <td>{item.reportType}</td>
                            <td>{item.manufacturingDate}</td>
                            <td>{item.expiryDate}</td>
                            <td>{item.batchNo}</td>
                            <td>{item.quantity}</td>
                            <td>Rs. {item.salePrice}</td>
                            <td>Rs. {item.price}</td>
                            <td>
                                Rs. {item.discountAmount} (
                                {item.discount}%)
                            </td>
                            <td>Rs. {item.taxableAmount}</td>
                            <td>Rs. {item.cgstAmount}</td>
                            <td>Rs. {item.sgstAmount}</td>
                            <td>Rs. {item.netAmount}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    };


    return (
        <div>
            <Table
                apiRequest={apiRequest}
                columns={columns}
                ref={tableRef}
                position={"top"}
                expandable={{
                    expandedRowKeys,
                    onExpandedRowsChange: (keys) => {
                        setExpandedRowKeys(keys || []);
                        if (keys && keys.length) {
                            keys.forEach((key) => fetchProductDetails(key));
                        }
                    },
                    expandedRowRender: expandedRowRender,
                }}
                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}

            />
        </div>
    )
}
export default PatientCreditNoteList